import { Text } from '@tiendanube/components';

function AuthorSkeleton(): JSX.Element {
  return <Text.Skeleton size="caption" />;
}

export default AuthorSkeleton;
